<template>
  <div class="module-detail-container">
    <!-- 主内容区 -->
    <div class="module-content">
      <!-- 1. 模块专属图片 -->
      <div class="module-specific-image">
        <img :src="currentModule.url" :alt="currentModule.title" />
      </div>

      <!-- 2. 新闻内容区 -->
      <div class="news-section" v-if="lookNews">
        <!-- 新闻列表 -->
        <div v-if="!showNewsList" class="news-wrapper">
          <template v-if="newsData.length">
            <news-list
              v-for="(item, index) in newsData"
              :key="index"
              :newData="item"
              @lookMore="lookMore"
              @lookMyEyes="lookMyEyes"
            />
          </template>
          <div v-else class="empty-box">
            <el-empty :image="require('@/assets/recycling/index/empty.svg')"></el-empty>
          </div>
        </div>

        <!-- 查看更多列表 -->
        <news-info
          v-else
          :choseNewTypeInfo="choseNewTypeInfo"
          @goBack="goBack"
          @lookMyEyes="lookMyEyes"
        />
      </div>

      <!-- 3. 新闻详情 -->
      <new-content
        v-else
        :newsContentInfo="newsContentInfo"
        @goParent="goParent"
        @goSecond="goSecond"
      />
    </div>
    <bottom-url />
  </div>
</template>

<script>
import bottomUrl from '@/components/bottomUrl/bottomUrl.vue';
import newsList from '@/views/policyInformation/component/newsList.vue';
import newsInfo from './component/newsInfo.vue';
import newContent from './component/newContent.vue';
import { getPunishmentList } from '@/API/news/news.js';
import { scrollTop } from '@/util/scrollTop';

export default {
  components: {
    bottomUrl,
    newsList,
    newsInfo,
    newContent,
  },
  data() {
    return {
      // 模块配置
      currentModule: {
        title: '市场风控',
        url: require('@/assets/recycling/index/scfk.png'),
      },
      // 新闻状态
      showNewsList: false,
      lookNews: true,
      newsData: [],
      choseNewTypeInfo: {},
      newsContentInfo: '',
    };
  },
  mounted() {
    this.getArticleList();
  },
  methods: {
    getArticleList() {
      getPunishmentList({ type: 'finance' }).then((res) => {
        if (res.code === 200 && res.data && res.data.length) {
          res.data.forEach((item) => {
            if (item.articles && item.articles.length > 10) {
              item.articles.length = 10;
            }
          });
          this.newsData = res.data;
        } else {
          this.newsData = [];
        }
      });
    },
    // 点击新闻标题，查看详情
    lookMyEyes(contentInfo) {
      this.lookNews = false;
      this.newsContentInfo = contentInfo;
      scrollTop();
    },
    // 点击"查看更多"
    lookMore(item) {
      this.choseNewTypeInfo = { name: item.name, id: item.id, description: item.description };
      this.showNewsList = true;
      scrollTop();
    },
    // 从"查看更多"列表返回
    goBack() {
      this.showNewsList = false;
      this.getArticleList();
      scrollTop();
    },
    // 从新闻详情返回首页
    goParent() {
      this.lookNews = true;
      this.showNewsList = false;
      this.getArticleList();
      scrollTop();
    },
    // 从新闻详情返回"查看更多"列表
    goSecond(info) {
      const parentId = info.parentId ? info.parentId[0] : null;
      let category = {};
      if (parentId) {
        category = this.newsData.find((item) => item.id == parentId) || {};
      }
      this.choseNewTypeInfo = {
        id: category.id || this.newsData[0]?.id,
        name: category.name || this.newsData[0]?.name,
      };
      this.showNewsList = true;
      this.lookNews = true;
      scrollTop();
    },
  },
};
</script>

<style lang="less" scoped>
.module-detail-container {
  width: 100%;
  margin: 0 auto;
  height: calc(100vh - 90px);
  overflow-y: auto;
  position: relative;
}

.module-content {
  width: 100%;
}

/* 模块专属图片样式 */
.module-specific-image {
  width: 100%;
  display: block;
}

.module-specific-image img {
  width: 100%;
  height: 730px;
  object-fit: cover;
}

/* 新闻内容区 */
.news-section {
  width: 1400px;
  margin: 0 auto 50px auto;
  padding-top: 20px;
}

.news-wrapper {
  width: 100%;
}

.empty-box {
  padding: 40px 0;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .module-detail-container {
    height: auto;
  }
  .module-content {
    height: auto;
    padding: 0 16px 180px;
    background-size: 90% auto;
  }
  .module-specific-image img {
    height: auto !important;
  }
  .news-section {
    width: 100%;
    padding: 0 10px;
  }
}
</style>
